import type { RouteObject } from "react-router-dom"
import { useRoutes } from "react-router-dom"
import { Suspense, lazy } from "react"
import { Toaster } from "react-hot-toast"
import Header from "@/components/Header"
import { CalculatorProvider } from "@/context/CalculatorContext"
import Home from "@/pages/Home"

const Formulas = lazy(() => import("@/pages/Formulas"))

export const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/formulas", element: <Formulas /> },
]

function AppRoutes() {
  return useRoutes(routes)
}

function App() {
  return (
    <CalculatorProvider>
      <div className="min-h-screen bg-[#FAFAFA]">
        <Header />
        <Suspense
          fallback={
            <div className="flex items-center justify-center min-h-[60vh]">
              <div className="w-8 h-8 border-2 border-indigo-200 border-t-indigo-600 rounded-full animate-spin" />
            </div>
          }
        >
          <AppRoutes />
        </Suspense>
      </div>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3500,
          style: {
            borderRadius: "10px",
            fontSize: "14px",
            fontWeight: "500",
          },
        }}
      />
    </CalculatorProvider>
  )
}

export default App
